var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('review&TestYourStore')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }